import { useState } from "react";
import "./FAQ.css";
import { FaPlus, FaMinus } from "react-icons/fa";

const faqData = [
  {
    question: "Which technologies do you use for website development?",
    answer:
      "We develop websites using React, PHP, Laravel, Bootstrap, MySQL, JavaScript and other modern technologies."
  },
  {
    question: "Do you provide custom software development?",
    answer:
      "Yes. We develop School ERP, Hospital Management, Inventory, HRMS, GST Billing, RTI Portal and other custom software."
  },
  {
    question: "Will my website be mobile responsive?",
    answer:
      "Absolutely. Every website is fully responsive and optimized for desktop, tablet and mobile devices."
  },
  {
    question: "Do you provide domain and hosting?",
    answer:
      "Yes. We provide domain registration, hosting setup, SSL certificate, business email and complete deployment."
  },
  {
    question: "Do you provide support after project completion?",
    answer:
      "Yes. We provide maintenance, bug fixing, updates and technical support after deployment."
  }
];

function FAQ() {

  const [active, setActive] = useState(null);

  const toggle = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="faq" id="faq">

      <div className="container">

        <div className="section-title">

          <h2>Frequently Asked Questions</h2>

          <p>
            Find answers to the most common questions about our services.
          </p>

        </div>

        <div className="faq-wrapper">

          {faqData.map((item, index) => (

            <div className="faq-item" key={index}>

              <button
                className="faq-question"
                onClick={() => toggle(index)}
              >
                <span>{item.question}</span>

                {active === index ? <FaMinus /> : <FaPlus />}
              </button>

              <div className={active === index ? "faq-answer open" : "faq-answer"}>

                <p>{item.answer}</p>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default FAQ;